import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "keywords" }

import { ref, watch } from 'vue'

import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import { ForumView } from '@/models/forum'


export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  props: {
    forum: {}
  },
  setup(__props: any) {

const props = __props

const search = ref('')

watch(search, (newSearch) => {
  props.forum.filter(newSearch)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InputWithContextMenu, {
      modelValue: search.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
      class: "keywords__input",
      placeholder: "Search",
      type: "text"
    }, null, 8, ["modelValue"]),
    _cache[1] || (_cache[1] = _createElementVNode("a", {
      class: "keywords__btn",
      href: "javascript:void(0);"
    }, [
      _createElementVNode("span", { class: "iconfont isearch" })
    ], -1))
  ]))
}
}

})